<script lang="ts">
	import Pagination from "svelte-pagination";
	import {
		totalPages,
		initPage,
		trigerBlackoutSearch,
		sizeSelect,
	} from "../../store/store";
	import { afterUpdate } from "svelte";
	import { navigate } from "svelte-routing";

	let wrapper;
	let checkedValue;
	export let totalRecord;
	export let bookingStatus = false;
	export let useNavigation = false;

	function handleChange(e) {
		const params: any = new Proxy(
			new URLSearchParams(window.location.search),
			{
				get: (searchParams, prop) => searchParams.get(String(prop)),
			}
		);
		const { selected } = e.detail;

		if (selected == 0) {
			selected == 1;
		} else {
			initPage.set(selected);
			checkedValue = selected;
			let searchParams = new URLSearchParams(window.location.search);
			searchParams.set("pageNumber", e.detail.selected);
			searchParams.set("page", e.detail.selected);
			var newRelativePathQuery =
				window.location.pathname + "?" + searchParams.toString();
			// trigerSelectIncompleteJob()
			if (useNavigation) {
				navigate(window.location.origin + newRelativePathQuery, {
					replace: true,
				});
				return;
			}
			if (bookingStatus) {
				trigerBlackoutSearch.set(false);

				trigerBlackoutSearch.set(true);
			} else {
				window.location.replace(
					window.location.origin + newRelativePathQuery
				);
			}
		}
	}

	function showDataRange(
		currentPage,
		totalPages,
		totalRecords,
		recordsPerPage
	) {
		if (currentPage > totalPages || currentPage < 1) {
			return "Invalid page number.";
		}
		const startRecord = (currentPage - 1) * recordsPerPage + 1;
		let endRecord = currentPage * recordsPerPage;
		endRecord = endRecord > totalRecords ? totalRecords : endRecord;

		return `Showing ${startRecord} - ${endRecord} of ${totalRecords}`;
	}

	afterUpdate(() => {
		if (wrapper && wrapper.querySelectorAll(".break-me").length > 2) {
			wrapper.querySelectorAll(".break-me")[1].remove();
			wrapper
				.querySelectorAll(".break-me")
				[wrapper.querySelectorAll(".break-me").length - 1].remove();
		} else if (
			wrapper &&
			wrapper.querySelectorAll(".break-me").length === 2
		) {
			wrapper.querySelectorAll(".break-me")[1].remove();
		}
	});
</script>

{#if totalRecord > 0}
	<div
		class="d-flex justify-content-between align-items-center mt-5 mb-1"
		bind:this={wrapper}
	>
		<div>{showDataRange($initPage, $totalPages, totalRecord, $sizeSelect)}</div>
		<Pagination
			pageCount={$totalPages + 1}
			disabledClassName={"disabled"}
			previousLabel={""}
			nextLabel={""}
			breakLabel={"..."}
			breakClassName={"break-me"}
			marginPagesDisplayed={2}
			pageRangeDisplayed={5}
			on:change={handleChange}
			pageClassName={"a"}
			initialPage={$initPage || 1}
			containerClassName={"pagination"}
			subContainerClassName={"pages"}
			activeClassName={"active"}
			activeLinkClassName={"active-link"}
		/>
	</div>
{/if}

<style>
	/*
      You can add following styles in a global stylesheets
    */
	:global(ul.pagination) {
		padding: 0 !important;
		margin: 0;
	}
	:global(ul.pagination li) {
		border: 1px solid var(--fds-outline-variant);
		border-radius: 8px;
		height: 40px;
		width: 40px;
	}

	:global(ul.pagination li:not(.previous):not(.next)) {
		margin: 0 4px;
	}

	:global(ul.pagination li.active) {
		background-color: var(--fds-primary) !important;
		border-color: var(--fds-primary) !important;
		color: white;
	}
	:global(ul.pagination li a) {
		color: black;
		float: left;
		padding: 5px 10px;
		text-decoration: none;
		text-align: center;
		width: 100%;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		background-repeat: no-repeat;
		background-position: center;
	}

	:global(li.previous a) {
		background-image: url("/assets/icon-chevron-left-thin.svg");
	}

	:global(li.next a) {
		background-image: url("/assets/icon-chevron-right-thin.svg");
		margin-right: 0 !important;
	}

	:global(li.disabled) {
		pointer-events: none;
		background-color: var(--fds-outline-variant);
	}

	:global(li.disabled a) {
		filter: opacity(0.3);
		-webkit-filter: opacity(0.3);
	}

	:global(.break-me) {
		pointer-events: none;
		cursor: none;
		-webkit-user-select: none; /* Chrome all / Safari all */
		-moz-user-select: none; /* Firefox all */
		-ms-user-select: none; /* IE 10+ */
		user-select: none;
		border: none !important;
	}
</style>
